import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ShieldCheck, ArrowRight } from "lucide-react";
export default function SafeguardingCapital() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: borderRef,
    isVisible: borderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="safeguarding-capital" className="dark bg-background text-foreground relative min-h-[85vh] flex items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 bg-background z-0" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col items-center text-center">
        
        {}
        <div ref={borderRef} className={`mb-8 transition-all duration-1000 ease-out ${borderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-muted-foreground border border-border/40 px-4 py-1.5 rounded-sm">
            <ShieldCheck className="w-3 h-3 text-primary" />
            <span>Credit Protection</span>
          </span>
        </div>

        {}
        <div ref={textRef} className="max-w-5xl mx-auto">
          <h1 className={`font-serif text-5xl md:text-7xl lg:text-8xl leading-[1.1] tracking-tight transition-all duration-1000 ease-out delay-200 ${textVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <span className="block text-transparent bg-clip-text bg-gradient-to-b from-white via-gray-200 to-gray-500 pb-2">
              Risk Mitigation through
            </span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-b from-gray-100 via-gray-400 to-gray-700">
              Institutional Protection.
            </span>
          </h1>

          <p className={`mt-8 text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto font-light tracking-wide transition-all duration-1000 ease-out delay-500 ${textVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            Safeguarding institutional-grade assets and capital flow with strategic credit structures designed for the modern financial landscape.
          </p>

          {}
          <div className={`mt-12 flex flex-col sm:flex-row items-center justify-center gap-6 transition-all duration-1000 ease-out delay-700 ${textVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <Button asChild variant="outline" className="h-14 px-8 text-base border-primary/20 hover:bg-primary/5 hover:border-primary/40 hover:text-white transition-all duration-300 rounded-none min-w-[200px]">
              <Link to="/ContactPage">
                Request Consultation
              </Link>
            </Button>
            
            <Button asChild variant="ghost" className="h-14 px-8 text-base text-muted-foreground hover:text-white hover:bg-transparent group rounded-none">
              <Link to="#solutions">
                Explore Solutions 
                <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border/20 to-transparent" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-32 bg-gradient-to-b from-border/20 to-transparent" />
    </section>;
}